import React from 'react';

import { SelectCustomizable } from 'core/chatbot/components/atoms/legacyAtoms';
import MultiSelectWithCheckbox from '../../../components/atoms/MultiSelectWithCheckbox/MultiSelectWithCheckbox';

import type { SelectOption } from '../useRadarView';

import './_radar-filters.scss';

/**
 * RadarFilters - Group and category filters shown in the radar header actions slot.
 */

type RadarFiltersProps = {
  categoryOptions: SelectOption[];
  groupOptions: SelectOption[];
  groupsPlaceholder: string;
  onCategoryChange: (option: SelectOption | null) => void;
  onGroupsChange: (options: SelectOption[] | null, meta?: { action?: string }) => void;
  selectedCategory: SelectOption;
  selectedGroupOptions: SelectOption[];
};

function RadarFilters({
  categoryOptions,
  groupOptions,
  groupsPlaceholder,
  onCategoryChange,
  onGroupsChange,
  selectedCategory,
  selectedGroupOptions,
}: Readonly<RadarFiltersProps>): JSX.Element {
  return (
    <div className="radar-filters">
      <MultiSelectWithCheckbox
        maxVisibleValues={1}
        onChange={onGroupsChange}
        options={groupOptions}
        placeholder={groupsPlaceholder}
        value={selectedGroupOptions}
      />
      <SelectCustomizable onChange={onCategoryChange} options={categoryOptions} size="default" value={selectedCategory} variant="default" />
    </div>
  );
}

export default RadarFilters;
